export enum ActionTypes {
  FETCH_USERS = "FETCH_USERS",
  FETCH_STATS = "FETCH_STATS",
}
